import { render } from "./Caption.vue?vue&type=template&id=0c543e74&scoped=true"
import script from "./Caption.vue?vue&type=script&lang=js"
export * from "./Caption.vue?vue&type=script&lang=js"

import "./Caption.vue?vue&type=style&index=0&id=0c543e74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c543e74"]])

export default __exports__